import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const AssetDetailsViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
AssetDetailsViewTopBar.displayName = "AssetDetailsViewTopBar"
